// Auth pages sometimes land with the identifier prefilled (return visits, the
// /join → /login existing-account handoff); jump the cursor to the password so
// the first keystroke is useful.
export default function FocusPasswordWhenPrefilled(prefilledInputId: string): void {
  const prefilled = document.getElementById(prefilledInputId) as HTMLInputElement | null
  if (prefilled?.value) {
    document.getElementById("user_password")?.focus()
  }
}
